import { useEffect, useState } from 'react';

const ONE_MINUTE = 60 * 1000;

/** Relit l'heure chaque minute, pour que les durées affichées avancent sans nouvelle donnée. */
export const useNow = (): Date => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), ONE_MINUTE);
    return () => clearInterval(interval);
  }, []);
  return now;
};
